function App() {
  return <h1>Cloudflare Test</h1>;
}

export default App;
